/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useEffect } from 'react';
import Select from 'react-select';
import { useTranslation } from 'react-i18next';
import { type FormikProps } from 'formik';
import Loading from '@components/Shared/Loader/Loading';
import useGetPersons from '@hooks/HR/use-get-persons';

interface LinesProps {
  formik: FormikProps<any>;
  isViewOnly?: boolean;
}

const PersonLines: React.FC<LinesProps> = ({ formik, isViewOnly = false }) => {
  const { values } = formik;
  const { i18n, t } = useTranslation();
  const { dataEmployees, loading, error } = useGetPersons(values.workshopId);
  // const { dataEmployees, loading, error } = useGetPersons(values.organizationId);
  // const { dataEmployees, loading, error } = useGetPersons();

  const handleLineChange = (index: number, field: string, value: any) => {
    const updatedLines = [...formik.values.equipmentsWorkOrderPersonList];
    updatedLines[index] = {
      ...updatedLines[index],
      [field]: value
    };
    formik.setFieldValue('equipmentsWorkOrderPersonList', updatedLines);
  };

  const handleAddLine = () => {
    const newLine: any = {
      personId: null,
      notes: ''
    };
    formik.setFieldValue('equipmentsWorkOrderPersonList', [...formik.values.equipmentsWorkOrderPersonList, newLine]);
  };

  const handleDeleteLine = (index: number) => {
    const updatedLines = values.equipmentsWorkOrderPersonList?.filter((_: any, i: number) => i !== index);

    formik?.setFieldValue('equipmentsWorkOrderPersonList', updatedLines);
  };
  const isRTL = i18n.language === 'ar';
  return (
    <>
      <Loading loading={loading} error={error} Type='Dots'>
        {!isViewOnly && (
          <div className=' d-flex justify-content-between bg-theme bg-opacity-15 mb-3'>
            <h5 className={`fw-bold border-start  border-4 border-theme p-2 m-0 d-flex align-items-center`}>
              <i className='fas fa-users-cog fa-fw me-2  '></i>
              {t('MaintenanceTeam')}
            </h5>

            <button type='button' className='btn btn-sm btn-theme' onClick={handleAddLine}>
              <i className='bi bi-person-plus me-2 fa-lg'></i>
              {t('Add')}
            </button>
          </div>
        )}

        {values.equipmentsWorkOrderPersonList?.length === 0 && (
          <div className='alert alert-info text-center'>
            <i className='fas fa-info-circle me-2'></i>
            {t('noTeamMembers')}
          </div>
        )}

        {values.equipmentsWorkOrderPersonList?.length > 0 && (
          <div className=''>
            <div
              className={`table-responsive rounded-2 text-center ${
                formik.errors.equipmentsWorkOrderPersonList ? ' ' : ''
              } `}
            >
              <div style={{ width: '100%' }}>
                <table className='table table-borderless  table-hover mb-0 '>
                  <thead className='' style={{ backgroundColor: 'var(--bs-tertiary-bg)' }}>
                    <tr>
                      <th className='align-middle' style={{ width: '2%' }}>
                        #
                      </th>
                      <th className='align-middle' style={{ width: '46%' }}>
                        {t('Employee')}
                      </th>

                      <th className='align-middle' style={{ width: '50%' }}>
                        {t('Note')}
                      </th>
                      <th hidden={isViewOnly} className='align-middle text-end' style={{ width: '2%' }}></th>
                    </tr>
                  </thead>
                  <tbody className='fw-bold'>
                    {values.equipmentsWorkOrderPersonList
                      ?.slice()
                      .reverse()
                      ?.map((line: any, index: any) => {
                        const Index = values.equipmentsWorkOrderPersonList?.length - 1 - index;

                        return (
                          <tr key={index}>
                            <td className='align-middle   small' style={{ backgroundColor: 'var(--bs-tertiary-bg)' }}>
                              {values.equipmentsWorkOrderPersonList?.length - index}
                            </td>
                            <td className='align-middle small'>
                              <Select
                                isDisabled={isViewOnly}
                                classNamePrefix='react-select'
                                className='w-100'
                                isSearchable
                                isClearable
                                options={dataEmployees}
                                value={dataEmployees.find((opt: any) => opt.value === line.personId) || null}
                                onChange={selectedOption =>
                                  handleLineChange(Index, 'personId', selectedOption?.value || null)
                                }
                                placeholder={i18n.language === 'ar' ? 'إختر' : 'Choose'}
                                menuPortalTarget={document.body}
                                styles={{
                                  menuPortal: (base: any) => ({ ...base, zIndex: 9999 })
                                }}
                                menuPlacement='top'
                                filterOption={(candidate, inputValue) => {
                                  // البحث في الاسم أو رقم الموظف
                                  const searchValue = inputValue.toLowerCase();
                                  const labelMatches = candidate?.label?.toLowerCase()?.includes(searchValue);
                                  const numberMatches = candidate?.data?.employeeNumber
                                    ?.toLowerCase()
                                    .includes(searchValue);
                                  return labelMatches || numberMatches;
                                }}
                                formatOptionLabel={option => (
                                  <div className='d-flex justify-content-between   '>
                                    <div className=''>{option.label}</div>
                                    <div className='text-theme fw-bold'>{option.employeeNumber}</div>
                                  </div>
                                )}
                              />
                            </td>

                            <td className='align-middle small'>
                              <input
                                disabled={isViewOnly}
                                className='form-control'
                                value={line.notes}
                                onChange={e => handleLineChange(Index, 'notes', e.target.value)}
                              />
                            </td>
                            <td className='align-middle small' hidden={isViewOnly}>
                              <button
                                type='button'
                                className='btn btn-outline-danger'
                                onClick={() => handleDeleteLine(Index)}
                              >
                                <i className='fas fa-trash-alt'></i>
                              </button>
                            </td>
                          </tr>
                        );
                      })}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        )}
      </Loading>
    </>
  );
};

export default PersonLines;
